import $ from "jquery";

class LoadMore {
	constructor() {
		this.init();
	}

    init() {
        this.dom();
        this.events();
    }

	dom() {
        this.$body = $('body');
        this.$loadLinks = this.$body.find('*[data-load-container][data-load-action][data-load-params]');
	}

    events() {
        this.$loadLinks.off('click.ClassMore');
        this.$loadLinks.on('click.ClassMore', this.clickLoadLinkHandler.bind(this));
    }

    clickLoadLinkHandler(event) {
        event.preventDefault();

        const $link = $(event.currentTarget);
        const $container = this.$body.find($link.data('load-container'));
        const action = $link.data('load-action');
        const params = $link.data('load-params');

        var count = $link.data('load-count');

        if (typeof count === 'undefined') {
            $link.attr('data-load-count', 1);
            count = 1;
        }
        
        if(!action) return;

        $container.addClass('loading');
        
        $.ajax({
            url: '/wp-admin/admin-ajax.php',
            data: {
                action: action,
                params: params,
                count: count
            },
            dataType: 'json',
            type: 'POST',
            success: function(response) {
                if (response.type === 'success') {
                    $container.append(response.html);

                    if(response.hide_load_btn) {
                        $link.hide();
                    }
                } else {
                    console.log(response.message);
                }
            },
            error: function() {
                console.log('Error.');
            },
            complete: function() {
                $container.removeClass('loading');
                $link.data('load-count', count + 1);
            }
        });

    }
}

export default LoadMore;